import { Component } from '@angular/core';

@Component({
    selector: 'lokos-unauthorised-access-page',
    templateUrl: './unauthorised-access-page.component.html',
    styleUrl: './unauthorised-access-page.component.scss',
    standalone: false,
})
export class UnauthorisedAccessPageComponent {}
